const quizAttemptStatus = {
  started: 'Started',
  passed: 'Passed',
  failed: 'Failed'
};

export default quizAttemptStatus;



// WEBPACK FOOTER //
// ./src/constants/quiz-attempt-status.js